import React, {Component} from 'react';
import './ratings-bar.css';

export default class RatingsBar extends Component {

  constructor(props) {
    super(props);
    this.state = { hoverIndex: 0 };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.renderStar = this.renderStar.bind(this);
    this.renderDescription = this.renderDescription.bind(this);
  }

  currentRating() {
    return this.props.newReview.rating === null ? 0 : this.props.newReview.rating;
  }

  currentRatingDescription() {
    switch(this.currentRating()) {
      case 1:
        return 'Disappointing';
      case 2:
        return 'Meh';
      case 3:
        return 'Okay';
      case 4:
        return 'Good';
      case 5:
        return 'Brilliant';
      default:
        return 'N/A';
    };
  }

  handleMouseEnter(starIndex) {
    this.setState({ ...this.state, hoverIndex: starIndex });
  }

  handleMouseLeave() {
    this.setState({ ...this.state, hoverIndex: 0 });
  }

  renderStar(index) {
    const starIndex = index + 1;
    let currRating = this.currentRating();
    if (currRating === null) { currRating = 0; }
    let fillClass = 'off';
    if (currRating >= starIndex) fillClass = 'on';
    if (this.state.hoverIndex >= starIndex) fillClass = 'hover';
    const className = `RatingsBar__star ${fillClass}`;
    return(
      <li
        key={index}
        className={className}
        data-rating={starIndex}
        onClick={() => this.props.changeRating(starIndex)}
        onMouseEnter={() => this.handleMouseEnter(starIndex)}
        onMouseLeave={this.handleMouseLeave}
      ></li>
    );
  }

  renderDescription() {
    const className = `RatingsBar__description r${this.currentRating()}`;
    if (this.currentRating() > 0) {
      return (
        <div className={className}>
          <span>{this.currentRatingDescription()}</span>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <section className="RatingsBar">
        <h2>Please rate your experience with this seller</h2>
        <div className="RatingsBar__stars">
          <ul>
            {this.renderStar(0)}
            {this.renderStar(1)}
            {this.renderStar(2)}
            {this.renderStar(3)}
            {this.renderStar(4)}
          </ul>
          {this.renderDescription()}
        </div>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/reviews/new/ratings-bar.js